import { render } from "./EditProceedingModal.vue?vue&type=template&id=4d49fa1f&scoped=true"
import script from "./EditProceedingModal.vue?vue&type=script&lang=js"
export * from "./EditProceedingModal.vue?vue&type=script&lang=js"

import "./EditProceedingModal.vue?vue&type=style&index=0&id=4d49fa1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d49fa1f"]])

export default __exports__